import { isPlatformBrowser } from '@angular/common';
import { Injectable } from '@angular/core';
import { ofType } from '@ngrx/effects';
import { ProductActions, ProductLoadingService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomProductLoadingService extends ProductLoadingService {
  /**
   * Метод был переопределен для фикса бага https://github.com/SAP/spartacus/issues/14415
   */
  protected getProductReloadTriggers(productCode: string, scope: string): Observable<unknown>[] {
    const triggers: Observable<unknown>[] = [];

    // max age trigger add
    const maxAge = this.loadingScopes.getMaxAge('product', scope);
    if (maxAge && isPlatformBrowser(this.platformId)) {
      // we want to grab load product success and load product fail for this product and scope
      const loadFinish$ = this.actions$.pipe(
        filter(
          (action: ProductActions.LoadProductSuccess | ProductActions.LoadProductFail) =>
            (action.type === ProductActions.LOAD_PRODUCT_SUCCESS || action.type === ProductActions.LOAD_PRODUCT_FAIL) &&
            action.meta.entityId === productCode &&
            action.meta.scope === scope,
        ),
      );

      const loadStart$ = this.actions$.pipe(
        ofType(ProductActions.LOAD_PRODUCT),
        filter((action: ProductActions.LoadProduct) => action.payload === productCode && action.meta.scope === scope),
      );

      triggers.push(this['getMaxAgeTrigger'](loadStart$, loadFinish$, maxAge));
    }

    const reloadTriggers$ = this.loadingScopes.getReloadTriggers('product', scope).map((e) => this.eventService.get(e));

    return triggers.concat(reloadTriggers$);
  }
}
